import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { v4 } from "uuid";
import { Link } from "react-router-dom";
import { Container, Row, Col, Table } from "reactstrap";
import { getAdsList } from "../../store/actions/ads";
import DatePicker from "../../components/Form/DatePicker"
import jMoment from "moment-jalaali";
import Typeahead from "../../components/Form/Typeahead";
import Button from "../../components/Form/Button";
import { enDigits } from "../../utils/formatDigits";
import { getAdsReport } from "../../requests/ads";
import Img from "../../components/Img";
import { MdInsertChart } from "react-icons/md";




const AdsList = props => {
  const [selectedAd, setSelectedAd] = useState([]);
  const [loading, setLoading] = useState(false);
  const [specificReport, setSpecificReport] = useState();
  const [generalReport, setGeneralReport] = useState();
  const [dates, setDates] = useState({
    startDate: jMoment().subtract(1, 'day').format('jYYYY-jM-jD'),
    endDate: jMoment().subtract(1, 'day').format('jYYYY-jM-jD')
  });
  useEffect(() => {
    if ((!props.ads || !Object.keys(props.ads).length) && !props.loading) {
      props.getAdsList();
    }
    window.scroll(0,0)
  }, [])
  const updateReport = ad => {
    if (ad) setSelectedAd([ad]);
    setLoading(true);
    getAdsReport({
      startDate: enDigits(dates.startDate),
      endDate: enDigits(dates.endDate),
      advertiseId: ad || selectedAd[0] || ad ? (ad || selectedAd[0]).id : null
    }).then(response => {
      if (response.data) {
        if (ad || selectedAd[0]) {
          setSpecificReport(response.data)
        } else {
          setGeneralReport(response.data)
        }
      }
      setLoading(false);
    }, err => {
      setLoading(false);
    })
  }
  if(!props.ads) return null;
  return (
    <Container fluid>
      <div className="d-flex align-items-center mb-4">
        <h4>گزارش نمایش تبلیغات</h4>
      </div>
      <Row>
        <Col xs="12" sm="6" md="3">
          از
          <DatePicker
            input={{
              onChange: value => setDates({
                ...dates,
                startDate: value
              }),
              value: dates.startDate
            }}
          />
        </Col>
        <Col xs="12" sm="6" md="3">
          تا
          <DatePicker
            input={{
              onChange: value => setDates({
                ...dates,
                endDate: value
              }),
              value: dates.endDate
            }}
          />
        </Col>
        <Col xs="12" sm="6" md="3">
          تبلیغ
          <Typeahead
            id="select-ad-typeahead"
            inputProps={{ id: 'select-ad' }}
            placeholder="انتخاب تبلیغ"
            emptyLabel="تبلیغی پیدا نشد"
            paginationText="نمایش موارد بیشتر"
            labelKey="name"
            clearButton
            onSearch={query => {
              if (query && !props.ads) {
                props.getAdsList();
              }
            }}
            options={Object.values(props.ads) || []}
            selected={selectedAd}
            onChange={selected => setSelectedAd(selected)}
          />
        </Col>
        <Col xs="12" sm="6" md="3">
          <br />
          <Button
            block
            color="success"
            onClick={() => updateReport()}
            loading={loading}
          >
            دریافت گزارش
          </Button>
        </Col>
        <Col xs="12">
          {generalReport && generalReport[0] && !selectedAd[0] &&
            <Table className="mt-3" responsive striped>
              <thead>
                <tr>
                  <th style={{ width: 40 }} />
                  <th>تبلیغ</th>
                  <th>تعداد نمایش</th>
                  <th>تعداد کلیک</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {generalReport.map(report => {
                  const ad = props.ads.filter(
                    item => item.id === report.advertise
                  )[0]
                  return (
                    <tr
                      key={ad.id}
                    >
                      <td className="v-align-middle">
                        <Img
                          src={
                            ad.cover ? `${ad.cover}/r/100x133` : ad.cover
                          }
                          width={30}
                          height={40}
                          fill="#e1e1e1"
                          className="rounded"
                        />
                      </td>
                      <td className="v-align-middle">
                        <Link to={`/ads/${ad.id}`} href={`/ads/${ad.id}`} title="ویرایش تبلیغ">
                          {ad.name}
                        </Link>
                      </td>
                      <td className="v-align-middle">{report.viewCount}</td>
                      <td className="v-align-middle">{report.clickCount}</td>
                      <td className="v-align-middle">
                        <Button className="has-icon" color="link" size="sm" onClick={() => {
                          updateReport(ad);
                        }} title="نمایش آمار این تبلیغ">
                          <MdInsertChart />
                        </Button>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          }
        </Col>
        <Col xs="12">
          {specificReport && specificReport[0] && !!selectedAd[0] &&
            <Table className="mt-3" responsive striped>
              <thead>
                <tr>
                  <th>کانال</th>
                  <th>تعداد نمایش</th>
                  <th>تعداد کلیک</th>
                </tr>
              </thead>
              <tbody>
                {specificReport.map(ad => (
                  <tr key={v4()}>
                    <td>{ad.channel}</td>
                    <td>{ad.viewCount}</td>
                    <td>{ad.clickCount}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          }
          {
            ((generalReport && !generalReport[0]) || (specificReport && !specificReport[0])) &&
            <p className="text-center p-5">چیزی برای نمایش دریافت نشد</p>
          }
        </Col>
      </Row>
    </Container>
  )
}


export default connect(
  state => (
    {
      ads: state.ads.list,
      loadingAd: state.loading.ad,
      loading: state.loading.ads
    }
  ),
  dispatch => bindActionCreators({
    getAdsList
  }, dispatch)
)(AdsList)